<template>
  <div>
    <b-breadcrumb :items="items" style="background-color: transparent"></b-breadcrumb>
    <b-container>
      <b-row>
        <b-col sm="12" style="padding: 34px 0">
          <h1 class="text-center">
            <span><img src="../assets/logo.png" width="70" alt=""></span><span class="nefro">Nefro</span><span class="atlas">Atlas</span>
          </h1>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid>
      <b-container style="padding: 64px 0">
        <b-row align-h="center">
          <b-col
            sm="10"
            md="3"
            v-for="modulo in modules"
            :key="modulo.id"
            style="padding-bottom: 20px;"
          >
            <router-link v-bind:to="modulo.path">
              <b-card-group>
                <b-card header-tag="header" footer-tag="footer" class="hoverme">
                  <template v-slot:footer>
                    <h6 class="mb-0 text-center">{{modulo.modulo}}</h6>
                  </template>
                  <b-card-text class="text-center">
                    <img v-bind:src="modulo.img" alt="modulos" width="100" height="100">
                  </b-card-text>
                </b-card>
              </b-card-group>
            </router-link>
          </b-col>
        </b-row>
      </b-container>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Categories",
  data() {
    return {
      items: [
          {
            text: 'Home',
            to: { name: 'categories' }
          }
        ],
      modules: [
        {
          id: 1,
          modulo: "Modulos",
          img: require("../assets/logo.png"),
          path: "/modulos"
        },
        {
          id: 2,
          modulo: "Provas",
          img: require("../assets/svg/code.svg"),
          path: "/provas"
        },
        {
          id: 3,
          modulo: "Relatorio",
          img: require("../assets/svg/feather/graph.svg"),
          path: "/dashboard"
        }
      ]
    };
  }
};
</script>

<style scoped>
a {
  color: #2c3e50;
}
.hoverme {
  box-shadow: 0px 7px 15px rgba(42, 42, 42, 0.667);
  transition: 0.5s;
}
.hoverme:hover {
  box-shadow: 0px 3px 5px rgba(42, 42, 42, 0.667);
  transition: 0.5s;
}
</style>